export const trandingImages = [
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657723857_D-protin_web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657724502_True-Elements_web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657735185_Web.png",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657723594_Ab-Find_web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657724502_True-Elements_web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657905291_Skin-elements_web_45.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657723594_Ab-Find_web.jpg",
];
